// extracted by mini-css-extract-plugin
module.exports = {"container":"contextual-menu-component_container__lV1D-","spacer":"contextual-menu-component_spacer__exwci"};